import { Component, HostListener, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { NavigationItem } from '@app/shared/types/navigation.types'
import { NavigationService } from '../navigation.service'
import { TokenService } from '@app/core/services/token.service'
import { I18nService } from '@app/core/i18n.service'
import { distinctUntilChanged } from 'rxjs';
import { environment } from '@env/environment'

@Component({
    selector: 'main-layout',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss'],
})
export class MainLayoutComponent implements OnInit {

    
    @HostListener('window:resize', ['$event'])
    onResize(event: any) { this.isSmallScreen = window.innerWidth < 680; }


    isSmallScreen: boolean = false

    /**
     * List of navigation items to show in the nav component(s)
     */
    navigationItems!: NavigationItem[];

    currentNavigationIndex: number = 0;


    hasNavTools: boolean = true;
    
    /**
     * Constructor
     */
    constructor(
        private _navigationService: NavigationService,
        protected i18nService: I18nService,
        private _tokenService: TokenService,
    ) {
        this.navigationItems = this._navigationService.navigationItems;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------


    ngOnInit(): void {

        this._navigationService.currentNavigationIndex$.pipe(distinctUntilChanged()).subscribe(index => {
            this.currentNavigationIndex = index;
        });
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * 
     * @param route 
     */
    navClick(route: string, navIndex: number) {
        this.currentNavigationIndex = navIndex;
        this._navigationService.currentNavigationIndex = navIndex;
    }

    /** */
    termsOfServiceNavigation() {
        window.open(environment.supportedLanguages['en-ca'].termsOfUse, "_bank")
    }

    /** */
    privacyPolicyNavigation() {
        window.open(environment.supportedLanguages['en-ca'].privacyPolicy, "_bank")
    }

    /** */
    contactUsNavigation() {}

    /** */
    logout() {
        this._tokenService.removeTokensAndOpenSessionDialog('logout')
    }

}
